export const locale = {
  'CREATETYPE' : {
    'TITLE' : {
      'CREATE' : 'Create type',
      'EDIT' : 'Edit type',
    },
    'CONFIRMBUTTON' : {
      'CREATE' : 'Create',
      'SAVE' : 'Save',
    },
    'NAME' : 'Type name',
  },
};
